// 區塊層級的錯誤邊界：某一區塊渲染出錯時只影響該區塊，其他部分照常運作。
import { Component, type ErrorInfo, type ReactNode } from 'react';
import { t } from '../i18n/zh-TW.ts';

interface Props {
  children: ReactNode;
  /** 用於日誌，識別是哪個區塊出錯 */
  name: string;
}

export class ErrorBoundary extends Component<Props, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(
      JSON.stringify({
        level: 'error',
        msg: '畫面區塊錯誤',
        block: this.props.name,
        error: error.message,
        stack: info.componentStack,
      }),
    );
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="state state-error" role="alert">
        <p className="state-title">{t.error.unknown}</p>
        <div className="state-actions">
          <button type="button" className="primary" onClick={() => this.setState({ error: null })}>
            {t.error.retry}
          </button>
        </div>
      </div>
    );
  }
}
